export default defineNuxtPlugin((nuxtApp) => {
  const components: Record<string, Component> = import.meta.glob(
    '@/node_modules/@lw-design-system/ui/dist/assets/svg/*.svg',
    {
      eager: true
    }
  );

  Object.entries(components).forEach(([path, component]) => {
    const pathSplit = path.split('/');
    const fileName = pathSplit[pathSplit.length - 1].split('.svg')[0];
    nuxtApp.vueApp.component(fileName, component);
  });
});
